export default __webpack_public_path__ + "7de389da03951b6f04623ff5622bdbca.png";